module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("4HH0D"))).then(() => parcelRequire('d0iPb'));